import React from "react";
import "../../assets/css/Loader.css";

export default function AppLoader({
  size = "sm",
  color = "primary",
  className = "",
  fullScreen = false,
  style = {},
}) {
  const spinnerElement = (
    <span
      className={`app-loader size-${size} color-${color} ${className}`}
      style={style}
      role="status"
      aria-label="Loading"
    />
  );

  if (fullScreen) {
    return (
      <div className="app-loader-overlay">
        <span
          className="app-loader size-lg color-primary"
          role="status"
          aria-label="Loading"
        />
      </div>
    );
  }

  return spinnerElement;
}
